import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  InvoiceWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { duesKeys } from "../dues.utils"

export type UseDuesInvoicesParams = QueryParamsDto

export const useDuesInvoices = (
  params?: UseDuesInvoicesParams,
  options?: UseQueryOptions<ResponseDto<InvoiceWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<InvoiceWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useDuesInvoices")

  const { server } = useServerContext()

  return useQuery({
    queryKey: duesKeys.findAllInvoices(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<InvoiceWithRelationsDto[]>>(
        buildQueryString("dues/invoices", params)
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
